<template lang="html">
  <div class="rating_survey">
    <server-form
      v-slot="slotProps"
      :form-action="formAction"
      :form="form"
      :show-top-errors="true">

      <rating-survey-question
        v-for="question in internalQuestions"
        :key="question.id"
        :question="question"
        :marking-titles="markingTitles"
        :form="form"
        :on-unable-to-answer-change="handleUnableToAnswerChange"
        :show-unable-to-answer="!isSelfAssesment"/>

    </server-form>
  </div>
</template>
<script>
import formAction from '../mixins/formAction'

export default {
  name: 'RatingSurvey',

  mixins: [formAction],

  props: {
    questions: {
      type: Array,
      required: true
    },

    markingTitles: {
      type: [Array, Object],
      required: true
    },

    isSelfAssesment: {
      type: Boolean,
      required: false,
      default: () => { return false }
    },

    savedResponses: {
      type: Object,
      required: false,
      default: () => { return [] }
    }
  },

  data () {
    return {
      form: {
        questions: {}
      },
      internalQuestions: []
    }
  },

  mounted () {
    this.internalQuestions = [
      ...this.internalQuestions,
      ...this.questions
    ]
    if (this.my360FormOld.questions) {
      this.setupQuestionsFromSourceObject(this.my360FormOld.questions)
    } else if (Object.keys(this.savedResponses).length > 0) {
      this.setupQuestionsFromSourceObject(this.savedResponses)
    } else {
      this.questions.forEach(question => {
        this.$set(this.form.questions, question.id, -1)
      })
    }
  },

  methods: {
    handleUnableToAnswerChange ($event, question) {
      this.$set(this.form.questions, question.id, !question.ignore ? -1 : 120)
    },

    setupQuestionsFromSourceObject (object) {
      this.questions.forEach(question => {
        if (object[question.id]) {
          var questionInt = parseInt(object[question.id].answer)
          if (questionInt === 120) {
            this.$set(this.internalQuestions, this.internalQuestions.indexOf(question), { ...question, ...{ ignore: true } })
          }
          this.$set(this.form.questions, question.id, questionInt)
        } else {
          this.$set(this.form.questions, question.id, -1)
        }
      })
    }
  }
}
</script>
